import MainRoutes from "routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "assets/fonts/fonts.css";

function App() {
  return (
    <div className=".main_container">
      <MainRoutes />
    </div>
  );
}

export default App;
